import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ElementRef,
    QueryList,
    ViewChildren,
    AfterViewInit
} from '@angular/core';
import { UploadEvent, FileSystemFileEntry, UploadFile } from 'ngx-file-drop';
import { AppConfigService } from '@core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalService } from '../local.services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Attachment, Local } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ProgressService } from '../probress-steps/progress.services';
import { AppAccordionComponent } from '@core/components/accordion/accordion.component';
import { VARIABLES } from 'environments/config';

@Component({
    selector: 'app-local-step-6',
    templateUrl: './step6.component.html',
    styleUrls: ['./step6.component.scss']
})
export class AppStep6Component implements OnInit, AfterViewInit, OnDestroy {
    @ViewChildren(AppAccordionComponent) accordions: QueryList<
        AppAccordionComponent
    >;
    alertDialogRef: MatDialogRef<AppAlertDialogComponent>;
    public files: UploadFile[] = [];
    local_id: any;
    attachments: Attachment[] = [];
    private _unsubscribeAll: Subject<any>;
    local: Local;

    filesFachada: Attachment[] = [];
    filesInterior: Attachment[] = [];
    filesEntorno: Attachment[] = [];

    @ViewChild('fachada') fachada: ElementRef;
    @ViewChild('interior') interior: ElementRef;
    @ViewChild('entorno') entorno: ElementRef;

    constructor(
        private _appConfig: AppConfigService,
        private _toastr: ToastrService,
        private _router: Router,
        public dialog: MatDialog,
        private _activatedRoute: ActivatedRoute,
        private _scrollService: ScrollService,
        private _progressService: ProgressService,
        private _localService: LocalService
    ) {
        this._appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.local = new Local();
        this._unsubscribeAll = new Subject();
    }
    ngOnInit(): void {
        this._activatedRoute.queryParams.subscribe(queryParams => {
            this._activatedRoute.params.subscribe(routeParams => {
                this.local_id = routeParams.id;
            });
        });

        this._localService.localOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.local = new Local(local);

                const _filesFachada = this.local.attachments.filter(
                    item => item.type === 'fachada'
                );
                if (_filesFachada.length > 0) {
                    this.filesFachada = _filesFachada;
                }

                const _filesInterior = this.local.attachments.filter(
                    item => item.type === 'interior'
                );
                if (_filesInterior.length > 0) {
                    this.filesInterior = _filesInterior;
                }

                const _filesEntorno = this.local.attachments.filter(
                    item => item.type === 'entorno'
                );
                if (_filesEntorno.length > 0) {
                    this.filesEntorno = _filesEntorno;
                }
            });
    }
    ngAfterViewInit() {
        this._scrollService._init();
    }
    async uploadDrag(type, event: UploadEvent, index) {
        const _formData: FormData = new FormData();
        _formData.set('type', type);
        for (const droppedFile of event.files) {
            if (droppedFile.fileEntry.isFile) {
                const fileEntry = (await droppedFile.fileEntry) as FileSystemFileEntry;
                fileEntry.file(async (file: File) => {
                    this.uploadFiles(file, _formData, type, index);
                });
            }
        }
    }

    async uploadSelect(type, event: any, index) {
        const selectedFiles: FileList[] = event.target.files;
        const _formData: FormData = new FormData();
        Array.from(selectedFiles).forEach(async (file: any) => {
            await this.uploadFiles(file, _formData, type, index);
        });
    }

    public async dropped(event: UploadEvent, type: string, index) {
        switch (type) {
            case 'fachada':
                if (this.filesFachada.length === 0 && event.files.length > 3) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesFachada.length + event.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadDrag(type, event, index);
                    }
                }
                break;
            case 'interior':
                if (this.filesInterior.length === 0 && event.files.length > 3) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesInterior.length + event.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadDrag(type, event, index);
                    }
                }
                break;
            case 'entorno':
                if (this.filesEntorno.length === 0 && event.files.length > 3) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesEntorno.length + event.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadDrag(type, event, index);
                    }
                }

                break;
        }
    }

    async onFileChanged(event, type: string, index) {
        switch (type) {
            case 'fachada':
                if (
                    this.filesFachada.length === 0 &&
                    event.target.files.length > 3
                ) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesFachada.length + event.target.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadSelect(type, event, index).then(
                            () => {}
                        );
                    }
                }
                break;
            case 'interior':
                if (
                    this.filesInterior.length === 0 &&
                    event.target.files.length > 3
                ) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesInterior.length + event.target.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadSelect(type, event, index).then(
                            () => {}
                        );
                    }
                }
                break;
            case 'entorno':
                if (
                    this.filesEntorno.length === 0 &&
                    event.target.files.length > 3
                ) {
                    this.clearInputs();
                    this.alert('Solo puedes subir 3 foto');
                } else {
                    const countFiles =
                        this.filesEntorno.length + event.target.files.length;
                    if (countFiles > 3) {
                        this.clearInputs();
                        this.alert('Solo puedes subir 3 foto');
                    } else {
                        await this.uploadSelect(type, event, index).then(
                            () => {}
                        );
                    }
                }

                break;
        }
    }

    getCountStep() {
        const count =
            this.filesFachada.length +
            this.filesFachada.length +
            this.filesFachada.length;
        if (count === 3) {
            return 6;
        }
        return 5;
    }

    async uploadFiles(file, _formData: FormData, type, index) {
        const ext = this.getExtension(file.name);

        if (
            ext === 'png' ||
            ext === 'jpg' ||
            ext === 'jpeg' ||
            ext === 'PNG' ||
            ext === 'JPG' ||
            ext === 'JPEG'
        ) {
            const size = file.size / 1024 / 1024;
            if (size > 5) {
                this._toastr.error(VARIABLES.MESSAGES.PHOTOS);
            } else {
                _formData.append('file', file, file.name);
                _formData.append('type', type);

                await this._localService
                    .addAttach(_formData)
                    .then((res: any) => {
                        switch (type) {
                            case 'fachada':
                                this.filesFachada.push(res.data);
                                this.setScroll(this.filesFachada, index);
                                break;
                            case 'interior':
                                this.filesInterior.push(res.data);
                                this.setScroll(this.filesInterior, index);
                                break;
                            case 'entorno':
                                this.filesEntorno.push(res.data);
                                this.setScroll(this.filesEntorno, index);
                                break;
                        }
                        this.clearInputs();
                    })
                    .catch(async (err: any) => {
                        this.clearInputs();
                        await this._toastr.error('Error al subir imagen');
                    });
            }
        } else {
            await this._toastr.error('Imagen no permitida');
            return;
        }
    }

    private setScroll(data: any[], index: number) {
        if (data.length === 3) {
            this.scrollTo(index);
        }
    }

    alert(msg) {
        this.alertDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.alertDialogRef.componentInstance.alertMessage = msg;
        this.alertDialogRef.afterClosed().subscribe(result => {
            this.alertDialogRef = null;
        });
    }

    remove(item: any, type) {
        if (item.hasOwnProperty('id')) {
            this._localService
                .deleteAttach(item.id)
                .then(async (res: any) => {
                    await this.getType(type, item);

                    this.clearInputs();
                })
                .catch((err: any) => {
                    if (err.ok === false && err.status === 400) {
                        this._toastr.error('Error al eliminar');
                    }
                    this.clearInputs();
                });
        } else {
            alert('Esta archivo no tiene ID');
        }
    }
    private getType(type: any, item: any) {
        switch (type) {
            case 'fachada':
                if (this.filesFachada.indexOf(item) !== -1) {
                    this.filesFachada.splice(
                        this.filesFachada.indexOf(item),
                        1
                    );
                }
                break;
            case 'interior':
                if (this.filesInterior.indexOf(item) !== -1) {
                    this.filesInterior.splice(
                        this.filesInterior.indexOf(item),
                        1
                    );
                }
                break;
            case 'entorno':
                if (this.filesEntorno.indexOf(item) !== -1) {
                    this.filesEntorno.splice(
                        this.filesEntorno.indexOf(item),
                        1
                    );
                }
                break;
        }
    }

    next() {
        let data = {};
        const _count =
            this.filesFachada.length > 0 &&
            this.filesInterior.length > 0 &&
            this.filesEntorno.length > 0;
        if (_count) {
            data = {
                steps: this._progressService.getCurrentIndex(6)
            };
        } else {
            data = {
                steps: this._progressService.removeCurrentIndex(6)
            };
        }

        this._localService
            .update(data)
            .then((res: any) => {
                this._router.navigate([`/local/registro/7/${this.local_id}`]);
            })
            .catch((err: any) => {
                this._toastr.error('Ocurrió un error, inténtalo nuevamente.');
            });
    }

    public fileOver(event) {}

    public fileLeave(event) {}

    prev() {
        this._router.navigate([`/local/registro/5/${this.local_id}`]);
    }
    skip() {
        this._router.navigate([`/local/registro/7/${this.local_id}`]);
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    getExtension(filename: any) {
        const ext = filename.split('.').pop();
        return ext === filename ? '' : ext;
    }
    getDisabled() {
        if (
            this.filesFachada.length === 3 &&
            this.filesInterior.length === 3 &&
            this.filesEntorno.length === 3
        ) {
            return true;
        }
        return false;
    }
    scrollTo(index) {
        const arrays: AppAccordionComponent = this.accordions.filter(
            item => item.key !== index && !item.check
        )[0];
        if (arrays) {
            this.accordions.forEach(async (aco: AppAccordionComponent) => {
                if (aco.key === index) {
                    aco.active = false;
                }
                if (aco.key === arrays.key) {
                    await this._scrollService._scrollTo(
                        'key-' + arrays.key,
                        -250
                    );
                    await setTimeout(() => {
                        aco.active = true;
                    }, 800);
                }
            });
        }
    }

    clearInputs() {
        if (this.fachada.nativeElement.value !== '') {
            this.fachada.nativeElement.value = '';
        }

        if (this.interior.nativeElement.value !== '') {
            this.interior.nativeElement.value = '';
        }

        if (this.entorno.nativeElement.value !== '') {
            this.entorno.nativeElement.value = '';
        }
    }
}
